interface IAddressActions {
	create?: boolean;
	update?: boolean;
	delete?: boolean;
}

interface IAddressFilter {
	Fax?: boolean;
	Email?: boolean;
	Phone?: boolean;
	POBox?: boolean;
	PostalAddress?: boolean;
}

class AddressListItem
{

	public static NEW: number			= 0;
	public static EDIT: number		= 1;
	public static REMOVED: number	= 2;
	private container: JQuery;
	private m_Form: Form;
	private m_Inputs: JQuery[];
	private m_Action: IAddressActions;
	private m_State?: number;
	private m_Address: { [key: string]: any } | string;
	private m_Type?: string;
	private	m_Manager: AddressManager;
	private m_Rand: number;

	private SAVEURL: string = 'address/new/';

	constructor(
		man: AddressManager,
		adr: number | string | Wollmilch.AddressObject,
		action: IAddressActions,
		filter: IAddressFilter,
		orientation?: string
	)
	{
		if ( typeof adr === 'string' && !( adr in filter ) )
		{
			throw new Error( 'FILTERED_ADDRESS_TYPE' );
		}

		this.m_Rand			= typeof adr === 'number' ? adr : Math.random();
		this.container	= ui.$$.div().addClass( 'list-group-item' );
		this.m_Inputs		= [];
		this.m_Action		= action;
		this.m_Manager	= man;
		this.m_Address	= '';
		this.m_Form			= new Form(
			{
				tag: 'div',
				orientation
			}
		);

		if ( typeof adr === 'number' )
		{
			( ( item: AddressListItem ) =>
				{
					new Wollmilch.AJAX(
						{
							url: 'address/show/' + adr,
							method: 'GET',
							data: null,
							on:
							{
								success( text: string )
								{
									try
									{
										const obj = JSON.parse( text );

										if ( !obj.success )
										{
											throw new Error( app.getMessage( 'AddressManager.ERROR.JSON_PARSE' ) );
										}

										item.m_Address = obj.data;
										item.m_Type = obj.type;

										if ( obj.type in filter )
										{
											item.createForm( AddressListItem.EDIT );
										}
										else
										{
											item.m_Manager.removeItem( item );
											return;
										}
									}
									catch ( e )
									{
										app.addNotify(
											{
												title: [ app.getSpanMessage( 'Aux.ERROR.JSON_PARSE' ) ],
												body: [ app.getSpanMessage( 'AddressManager.ERROR.JSON_PARSE' ) ],
												context: 'danger',
												timeout: Number(app.getConfigValue("ToastTimeout"))
											}
										);
									}
								}
							}
						}
					).send();
				}
			)( this );
		}
		else if ( typeof adr === 'object' )
		{
			this.m_Address	= adr;
			this.m_Type			= adr.AddressType;

			this.createForm( AddressListItem.NEW );
		}
		else
		{
			this.m_Address	= adr;
			this.m_Type			= adr;

			this.createForm( AddressListItem.NEW );
		}
	}

	public State(): number|undefined
	{
		return this.m_State;
	}

	public ID(): number
	{
		return this.m_Rand;
	}

	public Type(): string|undefined
	{
		return this.m_Type;
	}

	public remove(): void
	{
		this.container.remove();
	}

	public setState( state: number ) : void
	{
		this.m_State = state;

		this.updateFormButtons();
	}

	public getInputs() : JQuery[]
	{
		return this.m_Inputs;
	}

	public getElement() : JQuery
	{
		return this.container;
	}

	private createForm( state: number )
	{
		switch ( this.m_Type )
		{
			case 'Email':
				this.createEmail();
			 break;

			case 'Fax':
				this.createFax();
			 break;

			case 'Phone':
				this.createPhone();
			 break;

			case 'PostalAddress':
				this.createPostalAddress();
			 break;

			case 'POBox':
				this.createPOBox();
			 break;

			default: throw new Error( 'UNKNOWN_ADDRESS_TYPE_' + this.m_Type );
		}

		this.container.append( ui.h( 4, app.getMessage( 'AddressManager.TYPE.' + this.m_Type ) ) );
		this.container.append( this.m_Form.getElement() );
		this.setState( state );
	}

	private updateFormButtons(): void
	{
		this.m_Form.clearButtons();

		switch ( this.m_State )
		{
			case AddressListItem.NEW:
			this.createNEWButtons();
			break;

			case AddressListItem.EDIT:
			this.createEDITButtons();
			break;
		}
	}

	private createNEWButtons()
	{
		if ( this.m_Action.delete )
		{
			this.m_Form.addButton(
				new Button(
					{
						title: app.getMessage( 'Aux.ABORT_BTN' ),
						size: 'sm',
						style: 'warning',
						classes: [ 'pull-right' ],
						on:
						{
							click: () =>
							{
								this.m_Manager.removeItem( this );
							}
						}
					}
				)
			);
		}

		if ( this.m_Action.create )
		{
			let AdrType: string|number|string[];
			this.m_Form.addButton(
				new Button(
					{
						title: app.getMessage( 'Aux.SAVE_BTN' ),
						behaviour: 'button',
						style: 'success',
						classes: [ 'pull-right' ],
						size: 'sm',
						on:
						{
							click(): void
							{
								new Wollmilch.AJAX(
									{
										url: 'address/new/' + this.m_Type,
										async: true,
										data: null,
										method: 'POST',
										on:
										{
											beforeSend: ( o: Wollmilch.IAJAXOptions ): void =>
											{
												const inputs = this.getInputs();

												if ( o.data === null || typeof o.data === 'string' )
												{
													o.data = {};
												}

												for ( const i in inputs )
												{
													if ( !i ) { continue; }

													const name: string|undefined = inputs[ i ].attr( 'name' );

													if ( typeof name !== 'string' || name === '' )
													{
														continue;
													}

													if ( inputs[ i ].val() instanceof Array || inputs[ i ].val() === '' )
													{
														continue;
													}

													if ( name === 'KindOf' )
													{
														AdrType = inputs[ i ].val();
													}

													o.data[ name ] = inputs[ i ].val();
												}
											},
											success: ( text: string ): void =>
											{
												let obj: Wollmilch.ResponseObject;
												try
												{
													obj = JSON.parse( text );
												}
												catch ( e )
												{
													app.addNotify(
														{
															title: [],
															body: [ e.getMessage() ],
															context: 'danger',
															timeout: Number(app.getConfigValue("ToastTimeout"))
														}
													);

													return;
												}

												if ( !obj.success )
												{
													app.addNotify(
														{
															title: [],
															body: [],
															context: 'danger',
															timeout: Number(app.getConfigValue("ToastTimeout"))
														}
													);

													return;
												}

												this.m_Type			= obj.type;
												this.m_Address	= obj.data;

												new Wollmilch.AJAX(
													{
														url: 'organization/linkAddress/' + this.m_Manager.getRecipient() + '/' + obj.data.ID,
														method: 'POST',
														data: {KindOf: AdrType},
														on:
														{
															success: ( pText: string ): void =>
															{
																let obj_: Wollmilch.ResponseObject;
																try
																{
																	obj_ = JSON.parse( pText );
																}
																catch ( e )
																{
																	app.addNotify(
																		{
																			title: [],
																			body: [ e.getMessage() ],
																			context: 'danger',
																			timeout: Number(app.getConfigValue("ToastTimeout"))
																		}
																	);

																	return;
																}

																if ( obj_.success )
																{
																	this.setState( AddressListItem.EDIT );

																	app.addNotify(
																		{
																			title: [ app.getSpanMessage( 'AddressManager.TITLE.SAVE' ) ],
																			body: [ app.getSpanMessage( 'AddressManager.ACTION.SAVE_SUCCESS' ) ],
																			context: 'success',
																			timeout: Number(app.getConfigValue("ToastTimeout"))
																		}
																	);
																}
																else
																{
																	// Löschung der Adresse anstoßen, Antwort jedoch ignorieren, da wenn fehlschlägt nicht schlimm
																	new Wollmilch.AJAX( { url: 'address/remove/' + obj.data.ID, method: 'DELETE', data: null } ).send();
																}
															}
														}
													}
												).send();
											}
										}
									}
								).send();
							}
						}
					}
				)
			);
		}
	}

	private createEDITButtons()
	{
		if ( this.m_Action.delete && this.m_Action.update )
		{
			this.m_Form.addButton(
				new Button(
					{
						title: app.getMessage( 'Aux.DELETE_BTN' ),
						size: 'sm',
						style: 'danger',
						classes: [ 'pull-right' ],
						on:
						{
							click()
							{
								if ( typeof this.m_Address !== 'string' )
								{
									new Wollmilch.AJAX(
										{
											url: 'organization/unlinkAddress/' + this.m_Manager.getRecipient() + '/' + this.m_Address.ID,
											data: null,
											method: 'DELETE',
											on:
											{
												success: ( text: string ) : void =>
												{
													let obj: Wollmilch.ResponseObject;

													try
													{
														obj = JSON.parse( text );
													}
													catch ( e )
													{
														app.addNotify(
															{
																title: [ app.getSpanMessage( 'AddressManager.TITLE.REMOVE' ) ],
																body: [ e.getMessage() ],
																context: 'danger',
																timeout: Number(app.getConfigValue("ToastTimeout"))
															}
														);

														return;
													}

													if ( obj.success )
													{
														app.addNotify(
															{
																title: [ app.getSpanMessage( 'AddressManager.TITLE.REMOVE' ) ],
																body: [ app.getSpanMessage( 'AddressManager.TITLE.REMOVE_SUCCESS' ) ],
																context: 'success',
																timeout: Number(app.getConfigValue("ToastTimeout"))
															}
														);

														this.m_Manager.removeItem( this );

														// Löschung der Adresse anstoßen, Antwort jedoch ignorieren, da wenn fehlschlägt nicht schlimm
														if ( typeof this.m_Address !== 'string' )
														{
															new Wollmilch.AJAX(
																{
																	url: 'address/remove/' + this.m_Address.ID,
																	method: 'DELETE',
																	data: null
																}
															).send();
														}
													}
												}
											}
										}
									).send();
								}
							}
						}
					}
				)
			);
		}

		if ( this.m_Action.update )
		{
			this.m_Form.addButton(
				new Button(
					{
						title: app.getMessage( 'Aux.EDIT_BTN' ),
						behaviour: 'button',
						style: 'success',
						classes: [ 'pull-right' ],
						size: 'sm',
						on:
						{
							click(): void
							{
								if ( typeof this.m_Address === 'string' )
								{
									return;
								}

								new Wollmilch.AJAX(
									{
										url: 'address/edit/' + this.m_Address.ID,
										async: true,
										data: null,
										method: 'PATCH',
										on:
										{
											beforeSend: ( o: Wollmilch.IAJAXOptions ): void =>
											{
												const inputs = this.getInputs();

												if ( o.data == null || typeof o.data === 'string' )
												{
													o.data = {};
												}

												for ( const i in inputs )
												{
													if ( !i ) { continue; }

													const name: string|undefined = inputs[ i ].attr( 'name' );

													if ( typeof name !== 'string' || name === '' )
													{
														continue;
													}

													o.data[ name ] = inputs[ i ].val();
												}
											},
											success: ( text: string ): void =>
											{
												let obj: Wollmilch.ResponseObject;
												try
												{
													obj = JSON.parse( text );
												}
												catch ( e )
												{
													app.addNotify(
														{
															title: [],
															body: [ e.getMessage() ],
															context: 'danger',
															timeout: Number(app.getConfigValue("ToastTimeout"))
														}
													);

													return;
												}

												if ( !obj.success )
												{
													app.addNotify(
														{
															title: [],
															body: [],
															context: 'danger',
															timeout: Number(app.getConfigValue("ToastTimeout"))
														}
													);

													return;
												}

												this.m_Address	= obj.data;
											}
										}
									}
								).send();
							}
						}
					}
				)
			);
		}
	}

	private createEmail() : void
	{

		this.m_Inputs.push(
			this.m_Form.newFormGroup( [ 1 ] ).addItem(
				{
					input: new InputSelect(
						{
							name: 'KindOf'
						},
						{
							[app.getMessage( 'AddressManager.KindOf.HEAD' )]: '',
							[app.getMessage( 'AddressManager.KindOf.private' )]: 'private',
							[app.getMessage( 'AddressManager.KindOf.business' )]: 'business',
							[app.getMessage( 'AddressManager.KindOf.billing' )]: 'billing'
						}
					)
				}
			)
		);

		this.m_Inputs.push(
			this.m_Form.newFormGroup( [ 1 ] ).addItem(
				{
					input: new InputEmail(
						{
							value: typeof this.m_Address === 'string' ? '' : this.m_Address.Email,
							placeholder: 'Emailadresse',
							name: 'value',
							disabled: false
						}
					)
				}
			)
		);
	}

	private createFax( fax?: { [key: string]: string } ) : void
	{

		this.m_Inputs.push(
			this.m_Form.newFormGroup( [ 1 ] ).addItem(
				{
					input: new InputSelect(
						{
							name: 'KindOf'
						},
						{
							[app.getMessage( 'AddressManager.KindOf.HEAD' )]: '',
							[app.getMessage( 'AddressManager.KindOf.private' )]: 'private',
							[app.getMessage( 'AddressManager.KindOf.business' )]: 'business',
							[app.getMessage( 'AddressManager.KindOf.billing' )]: 'billing'
						}
					)
				}
			)
		);

		this.m_Inputs.push(
			this.m_Form.newFormGroup( [ 1 ] ).addItem(
				{
					input: new InputTel(
						{
							value: typeof this.m_Address === 'string' ? '' : this.m_Address.Number,
							placeholder: 'Faxnummer',
							name: 'value',
							disabled: false
						}
					)
				}
			)
		);
	}

	private createPhone( phone?: { [key: string]: string } ) : void
	{

		this.m_Inputs.push(
			this.m_Form.newFormGroup( [ 1 ] ).addItem(
				{
					input: new InputSelect(
						{
							name: 'KindOf'
						},
						{
							[app.getMessage( 'AddressManager.KindOf.HEAD' )]: '',
							[app.getMessage( 'AddressManager.KindOf.private' )]: 'private',
							[app.getMessage( 'AddressManager.KindOf.business' )]: 'business'
						}
					)
				}
			)
		);

		this.m_Inputs.push(
			this.m_Form.newFormGroup( [ 1 ] ).addItem(
				{
					label: new InputLabel(
						{
							value: 'Telefonnummer'
						}
					),
					input: new InputTel(
						{
							value: typeof this.m_Address === 'string' ? '' : this.m_Address.Number,
							placeholder: 'Telefonnummer',
							name: 'value',
							disabled: false
						}
					)
				}
			)
		);
		this.m_Inputs.push(
			this.m_Form.newFormGroup( [ 1 ] ).addItem(
				{
					label: new InputLabel(
						{
							value: 'Telefonnummerntyp'
						}
					),
					input: new InputText(
						{
							value: typeof this.m_Address === 'string' ? '' : this.m_Address.Type,
							placeholder: 'Typ',
							name: 'type',
							disabled: false
						}
					)
				}
			)
		);
		this.m_Inputs.push(
			this.m_Form.newFormGroup( [ 1 ] ).addItem(
				{
					label: new InputLabel(
						{
							value: 'Verfügbarkeit'
						}
					),
					input: new InputText(
						{
							value: typeof this.m_Address === 'string' ? '' : this.m_Address.Reachability,
							placeholder: 'Verfügbarkeit',
							name: 'reachability',
							disabled: false
						}
					)
				}
			)
		);
	}

	private createPOBox( pobox?: { [key: string]: string } ) : void
	{
		let group = this.m_Form.newFormGroup( [ 1 ] );

		this.m_Inputs.push(
			group.addItem(
				{
					input: new InputSelect(
						{
							name: 'KindOf'
						},
						{
							[app.getMessage( 'AddressManager.KindOf.HEAD' )]: '',
							[app.getMessage( 'AddressManager.KindOf.private' )]: 'private',
							[app.getMessage( 'AddressManager.KindOf.business' )]: 'business',
							[app.getMessage( 'AddressManager.KindOf.billing' )]: 'billing',
							[app.getMessage( 'AddressManager.KindOf.delivery' )]: 'delivery'
						}
					)
				}
			)
		);

		group = this.m_Form.newFormGroup( [ 1 ] );

		this.m_Inputs.push(
			group.addItem(
				{
					input: new InputText(
						{
							value: typeof this.m_Address === 'string' ? '' : this.m_Address.Box,
							placeholder: 'Box',
							name: 'box',
							disabled: false
						}
					)
				}
			)
		);
		group = this.m_Form.newFormGroup( [ 2, 4 ] );

		this.m_Inputs.push(
			group.addItem(
				{
					input: new InputText(
						{
							value: typeof this.m_Address === 'string' ? '' : this.m_Address.PostalCode,
							placeholder: 'Postal code',
							name: 'postalcode',
							disabled: false
						}
					)
				}
			)
		);
		this.m_Inputs.push(
			group.addItem(
				{
					input: new InputText(
						{
							value: typeof this.m_Address === 'string' ? '' : this.m_Address.City,
							placeholder: 'City',
							name: 'city',
							disabled: false
						}
					)
				}
			)
		);
		group = this.m_Form.newFormGroup( [ 1 , 1] );

		this.m_Inputs.push(
			group.addItem(
				{
					input: new InputText(
						{
							value: typeof this.m_Address === 'string' ? '' : this.m_Address.State,
							placeholder: 'State',
							name: 'state',
							disabled: false
						}
					)
				}
			)
		);

		this.m_Inputs.push(
			group.addItem(
				{
					input: new InputText(
						{
							value: typeof this.m_Address === 'string' ? '' : this.m_Address.Country,
							placeholder: 'Country',
							name: 'country',
							disabled: false
						}
					)
				}
			)
		);
	}

	private createPostalAddress( postaladdress?: { [key: string]: string } ) : void
	{
		let group = this.m_Form.newFormGroup( [ 1 ] );

		this.m_Inputs.push(
			group.addItem(
				{
					input: new InputSelect(
						{
							name: 'KindOf'
						},
						{
							[app.getMessage( 'Address.TYPE.KINDOF.HEAD' )]: '',
							[app.getMessage( 'Address.TYPE.KINDOF.private' )]: 'private',
							[app.getMessage( 'Address.TYPE.KINDOF.business' )]: 'business',
							[app.getMessage( 'Address.TYPE.KINDOF.domicile' )]: 'domicile'
						}
					)
				}
			)
		);

		group = this.m_Form.newFormGroup( [ 4, 2 ] );

		this.m_Inputs.push(
			group.addItem(
				{
					input: new InputText(
						{
							value: typeof this.m_Address === 'string' ? '' : this.m_Address.Street,
							placeholder: 'Street',
							name: 'street',
							disabled: false
						}
					)
				}
			)
		);

		this.m_Inputs.push(
			group.addItem(
				{
					input: new InputText(
						{
							value: typeof this.m_Address === 'string' ? '' : this.m_Address.HouseNumber,
							placeholder: 'Housenumber',
							name: 'housenumber',
							disabled: false
						}
					)
				}
			)
		);
		group = this.m_Form.newFormGroup( [ 2, 4 ] );

		this.m_Inputs.push(
			group.addItem(
				{
					input: new InputText(
						{
							value: typeof this.m_Address === 'string' ? '' : this.m_Address.PostalCode,
							placeholder: 'Postal code',
							name: 'postalcode',
							disabled: false
						}
					)
				}
			)
		);
		this.m_Inputs.push(
			group.addItem(
				{
					input: new InputText(
						{
							value: typeof this.m_Address === 'string' ? '' : this.m_Address.City,
							placeholder: 'City',
							name: 'city',
							disabled: false
						}
					)
				}
			)
		);
		group = this.m_Form.newFormGroup( [ 1 , 1] );

		this.m_Inputs.push(
			group.addItem(
				{
					input: new InputText(
						{
							value: typeof this.m_Address === 'string' ? '' : this.m_Address.State,
							placeholder: 'State',
							name: 'state',
							disabled: false
						}
					)
				}
			)
		);

		this.m_Inputs.push(
			group.addItem(
				{
					input: new InputText(
						{
							value: typeof this.m_Address === 'string' ? '' : this.m_Address.Country,
							placeholder: 'Country',
							name: 'country',
							disabled: false
						}
					)
				}
			)
		);
	}
}

class AddressManager
{
	private m_Element: JQuery;
	private m_AdrItems: AddressListItem[];
	private m_AdrGroup: JQuery;
	private m_NewAddressDropdown?: JQuery;
	private m_Recipient: number;
	private m_Action: IAddressActions;
	private m_Filter: IAddressFilter;

	constructor(
		recipient: number,
		adr: number[]|Wollmilch.AddressObject[],
		maxHeight?: number,
		actions: IAddressActions = {},
		filter: IAddressFilter = { Email: true, Fax: true, Phone: true, POBox: true, PostalAddress: true }
	)
	{
		this.m_Element		= ui.$$.div();

		this.m_Recipient	= recipient;
		this.m_AdrItems		= [];
		this.m_AdrGroup		= ui.$$.div();
		this.m_Action			= actions;
		this.m_Filter			= filter;

		if ( this.m_Action.create )
		{
			this.createNewAddressDropdown();
		}

		this.m_AdrGroup.addClass( 'list-group' );

		for ( const address in adr )
		{
			if ( !adr[address] ) { continue; }

			const item = new AddressListItem( this, adr[ address ], this.m_Action, filter, 'horizontal' );

			this.m_AdrItems.push( item );

			this.m_AdrGroup.append( item.getElement() );
		}

		if ( maxHeight && maxHeight > 50 )
		{
			this.m_AdrGroup.attr( 'style', 'overflow-y: scroll !important; max-height: ' + maxHeight + 'px;' );
		}

		this.m_Element.append( this.m_AdrGroup );
	}

	public removeItem( item: AddressListItem ) : void
	{
		let ii: any = null;
		for ( const i in this.m_AdrItems )
		{
			if ( item.ID() === this.m_AdrItems[ i ].ID() )
			{
				ii = i;

				break;
			}
		}

		if ( ii != null )
		{
			this.m_AdrItems[ ii ].remove();
			this.m_AdrItems.splice( ii, 1 );
		}
	}

	public getRecipient(): number
	{
		return this.m_Recipient;
	}

	public getItems() : AddressListItem[]
	{
		return this.m_AdrItems;
	}

	public getElement() : HTMLElement
	{
		return this.m_Element[ 0 ];
	}

	private createNewAddressDropdown() : void
	{
		if ( this.m_NewAddressDropdown )
		{
			return;
		}

		const btns: { [key: string]: () => void } = {
			Phone: (): void =>
			{
				const item = new AddressListItem( this, 'Phone', this.m_Action, this.m_Filter, 'horizontal' );

				this.m_AdrItems.push( item );

				this.m_AdrGroup.append( item.getElement() );
			},
			Fax: (): void =>
			{
				const item = new AddressListItem( this, 'Fax', this.m_Action, this.m_Filter, 'horizontal' );

				this.m_AdrItems.push( item );

				this.m_AdrGroup.append( item.getElement() );
			},
			Email: (): void =>
			{
				const item = new AddressListItem( this, 'Email', this.m_Action, this.m_Filter, 'horizontal' );

				this.m_AdrItems.push( item );

				this.m_AdrGroup.append( item.getElement() );
			},
			PostalAddress: (): void =>
			{
				const item = new AddressListItem( this, 'PostalAddress', this.m_Action, this.m_Filter, 'horizontal' );

				this.m_AdrItems.push( item );

				this.m_AdrGroup.append( item.getElement() );
			},
			POBox: (): void =>
			{
				const item = new AddressListItem( this, 'POBox', this.m_Action, this.m_Filter, 'horizontal' );

				this.m_AdrItems.push( item );

				this.m_AdrGroup.append( item.getElement() );
			}
		};

		this.m_NewAddressDropdown = $( ui.div() );

		this.m_Element.append( this.m_NewAddressDropdown );

		this.m_NewAddressDropdown.addClass( 'btn-group' );

		this.m_NewAddressDropdown.append(
			new Button(
				{
					style: 'info',
					size: 'sm',
					title: $( ui.span() )
									.append( ui.text( 'Neue Adresse hinzufügen' ) )
									.append( $( ui.span() ).addClass( 'caret' ) ),
					attr: {
						"data-toggle": "dropdown",
						"aria-haspopup": "true",
						"aria-expanded": "false"
					}
				}
			).getElement()
		);

		const dropdown: Dropdown = new Dropdown();

		for ( const i in btns )
		{
			if ( i in this.m_Filter )
			{
				dropdown.addItem().append(
					$( ui.a() ).append( i ).on( 'click', btns[ i ] ).css( 'cursor', 'pointer' )
				);
			}
		}

		this.m_NewAddressDropdown.append( dropdown.getElement() );
	}

}
